import { render, staticRenderFns } from "./ReferenceItem.vue?vue&type=template&id=376534a7&scoped=true&"
var script = {}
import style0 from "./ReferenceItem.vue?vue&type=style&index=0&id=376534a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376534a7",
  null
  
)

export default component.exports